import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
export function ProtectedRoute({ children }) {
    const { token, loading } = useAuth();
    if (loading) {
        return (_jsxs("div", { className: "loading-screen", children: [_jsx("div", { className: "spinner" }), _jsx("p", { children: "Y\u00FCkleniyor\u2026" })] }));
    }
    if (!token) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
